const PUBLIC_WRAPPER_BASE_QUERY_PARAM = "public_base";
const WHITE_LABEL_THEME_QUERY_PARAM = "theme";
const PUBLIC_WRAPPER_BASE_SESSION_KEY = "kav_public_wrapper_base";
const DEFAULT_ALLOWED_PUBLIC_WRAPPER_BASES = [
    "https://kav2go.nl/newway",
    "https://www.kav2go.nl/newway",
    "https://new.kav2go.nl/newway",
    "http://kav2go.localdomain/newway",
    "https://kav2go.nl/reserve",
    "https://www.kav2go.nl/reserve",
    "https://new.kav2go.nl/reserve",
    "http://kav2go.localdomain/reserve",
    "https://ensing.nl/newway",
    "https://www.ensing.nl/newway",
    "https://privateshare.com/newway",
    "https://www.privateshare.com/newway",
];

export const normalizePublicWrapperBase = (value = "") => {
    const rawValue = String(value || "").trim();
    if (!rawValue) return "";

    try {
        const url = new URL(rawValue);
        if (!["http:", "https:"].includes(url.protocol)) return "";
        url.search = "";
        url.hash = "";
        return url.toString().replace(/\/+$/, "");
    } catch (_error) {
        return "";
    }
};

const getAllowedPublicWrapperBases = () => {
    const envBases = String(process.env.REACT_APP_ALLOWED_PUBLIC_WRAPPER_BASES || "")
        .split(",")
        .map((item) => normalizePublicWrapperBase(item))
        .filter(Boolean);

    return [
        ...DEFAULT_ALLOWED_PUBLIC_WRAPPER_BASES.map((item) => normalizePublicWrapperBase(item)),
        ...envBases,
    ].filter(Boolean);
};

export const isAllowedPublicWrapperBase = (base) => {
    const normalizedBase = normalizePublicWrapperBase(base);
    if (!normalizedBase) return false;

    if (getAllowedPublicWrapperBases().includes(normalizedBase)) {
        return true;
    }

    if (process.env.NODE_ENV !== "production") {
        try {
            const url = new URL(normalizedBase);
            return ["localhost", "127.0.0.1"].includes(url.hostname);
        } catch (_error) {
            return false;
        }
    }

    return false;
};

export const resolvePublicWrapperBase = (queryParams) => {
    if (typeof window === "undefined") return "";

    const queryBase = normalizePublicWrapperBase(queryParams.get(PUBLIC_WRAPPER_BASE_QUERY_PARAM));
    if (isAllowedPublicWrapperBase(queryBase)) {
        try {
            window.sessionStorage.setItem(PUBLIC_WRAPPER_BASE_SESSION_KEY, queryBase);
        } catch (_error) {
            // Some browsers restrict storage in embedded contexts; the current URL can still use queryBase.
        }
        return queryBase;
    }

    let storedBase = "";
    try {
        storedBase = normalizePublicWrapperBase(window.sessionStorage.getItem(PUBLIC_WRAPPER_BASE_SESSION_KEY));
    } catch (_error) {
        storedBase = "";
    }
    if (isAllowedPublicWrapperBase(storedBase)) {
        return storedBase;
    }

    return window.location.origin;
};

export const appendPublicWrapperBaseToSearch = (searchParams, sourceSearch = "") => {
    const nextSearchParams = searchParams instanceof URLSearchParams
        ? searchParams
        : new URLSearchParams(searchParams || "");
    const fallbackSourceSearch = typeof window !== "undefined" ? window.location.search : "";
    const sourceParams = new URLSearchParams(sourceSearch || fallbackSourceSearch || "");
    const publicWrapperBase = resolvePublicWrapperBase(sourceParams);
    const explicitThemeId = String(sourceParams.get(WHITE_LABEL_THEME_QUERY_PARAM) || "").trim().toLowerCase();

    if (isAllowedPublicWrapperBase(publicWrapperBase)) {
        nextSearchParams.set(PUBLIC_WRAPPER_BASE_QUERY_PARAM, publicWrapperBase);
    }

    if (explicitThemeId) {
        nextSearchParams.set(WHITE_LABEL_THEME_QUERY_PARAM, explicitThemeId);
    }

    return nextSearchParams;
};

export const buildPublicReservationUrl = ({baseUrl, pathname, searchParams}) => {
    const normalizedBase = normalizePublicWrapperBase(baseUrl);
    if (!normalizedBase) return ""; 

    const normalizedPathname = `/${String(pathname || "").replace(/^\/+/, "")}`;
    const url = new URL(`${normalizedBase}${normalizedPathname}`);
    if (searchParams) {
        url.search = searchParams.toString();
    }
    return url.toString();
};
